import { colors } from "@components/ui/colors";

export const NOTE_TYPES = {
  general: {
    label: "General",
    color: colors.gray[600],
    bg: colors.gray[100],
  },

  followup: {
    label: "Follow-up",
    color: colors.info?.base || "#2563EB",
    bg: "#EFF6FF",
  },

  urgent: {
    label: "Urgent",
    color: colors.red?.[500] || "#DC2626",
    bg: "#FEF2F2",
  },

  billing: {
    label: "Billing",
    color: colors.orange[600],
    bg: colors.orange[50],
  },

  job: {
    label: "Job",
    color: "#0284c7",
    bg: "#e0f2fe",
  },

  visit: {
    label: "Visit",
    color: "#0f766e",
    bg: "#ccfbf1",
  },
};

export const formatRelativeDate = (date) => {
  if (!date) return "";

  const value = new Date(date);

  if (Number.isNaN(value.getTime())) {
    return "";
  }

  const now = new Date();

  const difference = now.getTime() - value.getTime();

  const seconds = Math.floor(difference / 1000);

  const minutes = Math.floor(seconds / 60);

  const hours = Math.floor(minutes / 60);

  const days = Math.floor(hours / 24);

  if (seconds < 60) {
    return "Just now";
  }

  if (minutes < 60) {
    return `${minutes}m ago`;
  }

  if (hours < 24) {
    return `${hours}h ago`;
  }

  if (days < 7) {
    return `${days}d ago`;
  }

  return value.toLocaleDateString();
};

export const getFilteredNotes = ({ notes, filter, search, currentUserUid, tagFilter }) => {
  const normalizedSearch = search?.trim().toLowerCase() || "";

  return [...notes]
    .filter((note) => {
      if (filter === "mine") {
        return note.userUid === currentUserUid;
      }

      if (filter === "pinned") {
        return note.pinned;
      }

      return true;
    })
    .filter((note) => {
      if (!tagFilter || tagFilter === "all") {
        return true;
      }

      return note.type === tagFilter;
    })
    .filter((note) => {
      if (!normalizedSearch) {
        return true;
      }

      return note.content?.toLowerCase().includes(normalizedSearch);
    })
    .sort((a, b) => {
      if (a.pinned !== b.pinned) {
        return Number(b.pinned) - Number(a.pinned);
      }

      return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
    });
};
